import React from "react";
var __jsx = React.createElement;
import { BottomSheet } from "@componentsShared/BottomSheet";
import { useCart } from "@/common/Contexts/CartContext";
import useTranslation from "@/i18n/useTranslation";
var CartCancelIcon = function CartCancelIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "80",
    height: "80",
    rx: "17.0895",
    fill: "#FEFAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0269 42.6214L44.7843 37.3789H49.306L56.5145 24.2725H31.6779L26.4354 19.03H60.8396C61.8444 19.03 62.6203 19.4563 63.1673 20.3091C63.7143 21.1619 63.7248 22.0899 63.1988 23.0929L53.8932 39.8691C53.4127 40.7428 52.7905 41.42 52.0269 41.9006C51.2632 42.3811 50.5965 42.6214 50.0269 42.6214ZM26.8941 66.2129C25.4524 66.2129 24.2187 65.7 23.1929 64.6742C22.1671 63.6484 21.6533 62.4138 21.6516 60.9703C21.6498 59.5269 22.1636 58.2931 23.1929 57.2691C24.2222 56.245 25.4559 55.7313 26.8941 55.7278C28.3323 55.7243 29.5669 56.238 30.598 57.2691C31.629 58.3001 32.1419 59.5339 32.1367 60.9703C32.1314 62.4068 31.6185 63.6414 30.598 64.6742C29.5774 65.707 28.3428 66.2199 26.8941 66.2129ZM60.4464 67.7856L45.6362 53.1065H28.4669C26.5446 53.1065 25.0811 52.2878 24.0763 50.6504C23.0714 49.0129 23.0059 47.2978 23.8797 45.5048L26.632 39.8691L21.9137 29.2529L12.215 19.5542C11.7344 19.0736 11.4941 18.462 11.4941 17.7193C11.4941 16.9766 11.7344 16.365 12.215 15.8844C12.6956 15.4039 13.3072 15.1636 14.0499 15.1636C14.7926 15.1636 15.4042 15.4039 15.8848 15.8844L64.1162 64.1158C64.5968 64.5964 64.8484 65.1976 64.8711 65.9193C64.8938 66.641 64.6422 67.2631 64.1162 67.7856C63.6356 68.2662 63.024 68.5065 62.2813 68.5065C61.5386 68.5065 60.927 68.2662 60.4464 67.7856ZM40.3937 47.864L35.1511 42.6214H31.0882L28.4669 47.864H40.3937ZM49.4056 64.6742C48.3781 63.6466 47.8643 62.412 47.8643 60.9703C47.8643 59.5286 48.3781 58.2949 49.4056 57.2691C50.4332 56.2433 51.6669 55.7295 53.1068 55.7278C54.5468 55.726 55.7814 56.2398 56.8107 57.2691C57.84 58.2984 58.3529 59.5321 58.3494 60.9703C58.3459 62.4085 57.833 63.6431 56.8107 64.6742C55.7884 65.7052 54.5538 66.2181 53.1068 66.2129C51.6599 66.2076 50.4262 65.6947 49.4056 64.6742Z",
    fill: "#EC6234"
  }));
};
var OilCancelModal = function OilCancelModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useCart = useCart(),
    clearCart = _useCart.clearCart;
  var _useTranslation = useTranslation(["web_oils"]),
    tShort = _useTranslation.tShort;
  var handleClear = function handleClear() {
    clearCart();
    onClose();
  };
  return /*#__PURE__*/React.createElement(BottomSheet, {
    open: open,
    onOpen: function onOpen() {},
    onClose: onClose,
    haveClose: true,
    hideTitleBar: true,
    customClassName: "oil-modal",
    modalDesign: {
      closeAnimation: false
    },
    maxWidthDesktop: "900px",
    screens: [{
      component: /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col items-center gap-4 pb-4 px-6"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-4"
      }, /*#__PURE__*/React.createElement(CartCancelIcon, null)), /*#__PURE__*/React.createElement("h3", {
        className: "text-xl font-extrabold text-[#1B2035] text-center leading-8"
      }, tShort("cancel_modal/title", {
        ns: "web_oils"
      })), /*#__PURE__*/React.createElement("p", {
        className: "text-base text-[#09090B] md:text-[#000] text-center m-0 leading-relaxed"
      }, tShort("cancel_modal/description", {
        ns: "web_oils"
      })), /*#__PURE__*/React.createElement("button", {
        className: "w-80 mx-auto mt-2 py-2 bg-primary-new text-white border-none rounded-[4px] text-base cursor-pointer transition-colors text-center",
        onClick: onClose
      }, tShort("cancel_modal/continue", {
        ns: "web_oils"
      })), /*#__PURE__*/React.createElement("button", {
        className: "w-80 mx-auto bg-transparent border-none text-primary-new text-base font-semibold cursor-pointer py-2 text-center",
        onClick: handleClear
      }, tShort("cancel_modal/clear_cart", {
        ns: "web_oils"
      })))
    }]
  });
};
export default OilCancelModal;